<!-- src/app/components/header/header.html -->
<header
  class="scrolled sticky top-0 z-50 bg-white"
  role="banner"
>
  <div class="container flex items-center justify-between h-16 lg:h-20">
    <!-- Logo -->
    <a routerLink="/" class="flex items-center gap-3" aria-label="Orient House">
      <img
        src="/assets/ohdc-logo-dark.svg"
        alt="Orient House for Development & Constructions"
        class="h-12 w-auto select-none"
        draggable="false"
      />
      <span class="sr-only">Orient House</span>
    </a>
    <!-- <a
      routerLink="/"
      (click)="closeMenu()"
      class="flex items-center gap-2"
      aria-label="Orient House"
    >
      <span class="inline-flex items-center leading-none select-none">
        <span class="mr-2 h-2.5 w-2.5 rounded-sm bg-ink"></span>
        <span class="font-semibold tracking-[0.06em] text-white text-lg sm:text-base">
          Orient House
        </span>
      </span>
    </a> -->

    <!-- Desktop Nav -->
    <nav class="hidden lg:block" aria-label="Primary">
      <ul class="flex items-center gap-8 text-sm">
        <li>
          <a
            routerLink="/"
            class="hdr-link text-white/75 hover:text-white transition-colors duration-200 relative after:content-[''] after:absolute after:left-0 after:-bottom-1.5 after:h-0.5 after:w-0 after:rounded-full after:bg-white after:transition-all after:duration-300 hover:after:w-full rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-4 focus-visible:ring-offset-ink"
            routerLinkActive="!text-white after:!w-full is-active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            Home
          </a>
        </li>

        <li>
          <a
            routerLink="/about"
            class="hdr-link text-white/75 hover:text-white transition-colors duration-200 relative after:content-[''] after:absolute after:left-0 after:-bottom-1.5 after:h-0.5 after:w-0 after:rounded-full after:bg-white after:transition-all after:duration-300 hover:after:w-full rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-4 focus-visible:ring-offset-ink"
            routerLinkActive="!text-white after:!w-full is-active"
          >
            About
          </a>
        </li>

        <li>
          <a
            routerLink="/"
            fragment="why-orient-house"
            class="hdr-link text-white/75 hover:text-white transition-colors duration-200 relative after:content-[''] after:absolute after:left-0 after:-bottom-1.5 after:h-0.5 after:w-0 after:rounded-full after:bg-white after:transition-all after:duration-300 hover:after:w-full rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-4 focus-visible:ring-offset-ink"
          >
            Why Orient House
          </a>
        </li>

        <li class="relative group" (mouseleave)="servicesMenuClosed = false">
          <a
            routerLink="/services"
            (click)="closeServicesMenu($event)"
            class="hdr-link text-white/75 hover:text-white transition-colors duration-200 relative after:content-[''] after:absolute after:left-0 after:-bottom-1.5 after:h-0.5 after:w-0 after:rounded-full after:bg-white after:transition-all after:duration-300 hover:after:w-full rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-4 focus-visible:ring-offset-ink"
            routerLinkActive="!text-white after:!w-full is-active"
          >
            Services
          </a>

          <!-- Flyout (hidden right after a click until the pointer leaves) -->
          <div
            [class.!hidden]="servicesMenuClosed"
            class="pointer-events-none absolute left-1/2 top-full z-50 w-[300px] -translate-x-1/2 pt-4 opacity-0 translate-y-2 transition-all group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto group-focus-within:opacity-100 group-focus-within:translate-y-0 group-focus-within:pointer-events-auto"
          >
            <ul
              class="grid grid-cols-1 gap-1 rounded-xl border border-orientLine bg-paper p-3 text-sm shadow-card"
            >
              <li *ngFor="let s of services">
                <a
                  [routerLink]="['/services', s.slug]"
                  (click)="closeServicesMenu($event)"
                  class="block rounded-md px-3 py-2 text-ink/80 hover:text-ink hover:bg-orientGray transition-colors"
                  routerLinkActive="!bg-orientGray !text-ink font-medium"
                  >{{ s.title }}</a
                >
              </li>
            </ul>
          </div>
        </li>

        <li>
          <a
            routerLink="/projects"
            class="hdr-link text-white/75 hover:text-white transition-colors duration-200 relative after:content-[''] after:absolute after:left-0 after:-bottom-1.5 after:h-0.5 after:w-0 after:rounded-full after:bg-white after:transition-all after:duration-300 hover:after:w-full rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-4 focus-visible:ring-offset-ink"
            routerLinkActive="!text-white after:!w-full is-active"
          >
            Projects
          </a>
        </li>

        <li>
          <a
            routerLink="/hse"
            class="hdr-link text-white/75 hover:text-white transition-colors duration-200 relative after:content-[''] after:absolute after:left-0 after:-bottom-1.5 after:h-0.5 after:w-0 after:rounded-full after:bg-white after:transition-all after:duration-300 hover:after:w-full rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-4 focus-visible:ring-offset-ink"
            routerLinkActive="!text-white after:!w-full is-active"
          >
            HSE
          </a>
        </li>
        <li>
          <a
            routerLink="/quality"
            class="hdr-link text-white/75 hover:text-white transition-colors duration-200 relative after:content-[''] after:absolute after:left-0 after:-bottom-1.5 after:h-0.5 after:w-0 after:rounded-full after:bg-white after:transition-all after:duration-300 hover:after:w-full rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-4 focus-visible:ring-offset-ink"
            routerLinkActive="!text-white after:!w-full is-active"
          >
            Quality
          </a>
        </li>
      </ul>
    </nav>

    <!-- Right side -->
    <div class="flex items-center gap-3">
      <a
        routerLink="/contact"
        routerLinkActive="ring-2 ring-white/60 ring-offset-2 ring-offset-ink"
        class="hdr-cta group relative hidden sm:inline-flex items-center justify-center px-6 h-11 rounded-full bg-white text-ink text-sm font-medium border border-transparent shadow-sm overflow-hidden transition-all duration-300 hover:bg-orientBlue hover:text-white hover:border-white/20 hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0 focus:outline-none focus:ring-2 focus:ring-white/30 before:absolute before:inset-0 before:bg-[linear-gradient(120deg,transparent,rgba(255,255,255,.25),transparent)] before:-translate-x-full hover:before:translate-x-full before:transition-transform before:duration-700"
      >
        <span class="relative z-10"> Contact </span>
      </a>

      <!-- Mobile toggle -->
      <button
        type="button"
        class="hdr-burger inline-flex lg:hidden items-center justify-center h-10 w-10 rounded-md text-white border border-orientLine focus:outline-none focus:ring-2 focus:ring-orientBlue"
        (click)="toggleMenu()"
        [attr.aria-expanded]="isMenuOpen"
        aria-controls="mobile-menu"
        aria-label="Open menu"
      >
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none">
          <path
            d="M4 7h16M4 12h16M4 17h16"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>
  </div>

  <!-- Mobile Menu -->
  <div
    id="mobile-menu"
    class="fixed inset-0 z-50 lg:hidden flex flex-col bg-ink text-white"
    *ngIf="isMenuOpen"
  >
    <!-- Top bar -->
    <div
      class="flex items-center justify-between h-16 px-4 border-b border-white/10"
    >
      <!-- text wordmark -->
      <a
        routerLink="/"
        class="flex items-center gap-3"
        aria-label="Orient House"
      >
        <img
          src="/assets/ohdc-logo white.svg"
          alt="Orient House for Development & Constructions"
          class="h-12 w-auto select-none"
          draggable="false"
        />
        <span class="sr-only">Orient House</span>
      </a>

      <button
        class="inline-flex items-center justify-center h-10 w-10 rounded-md border border-white/15 text-white/90 hover:text-white hover:border-white/30 focus:outline-none focus:ring-2 focus:ring-white/30"
        (click)="closeMenu()"
        aria-label="Close menu"
      >
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none">
          <path
            d="M6 6l12 12M18 6 6 18"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>

    <!-- Links -->
    <nav class="flex-1 min-h-0 px-4 py-6 overflow-y-auto" aria-label="Mobile">
      <ul class="flex flex-col gap-2">
        <li>
          <a
            routerLink="/"
            (click)="closeMenu()"
            class="block rounded-xl px-4 py-4 text-white/80 hover:text-white hover:bg-white/5 text-2xl tracking-[0.01em] transition-colors"
            routerLinkActive="!bg-white/10 !text-white"
            [routerLinkActiveOptions]="{ exact: true }"
            >Home</a
          >
        </li>
        <li>
          <a
            routerLink="/about"
            (click)="closeMenu()"
            class="block rounded-xl px-4 py-4 text-white/80 hover:text-white hover:bg-white/5 text-2xl tracking-[0.01em] transition-colors"
            routerLinkActive="!bg-white/10 !text-white"
            >About</a
          >
        </li>
        <li>
          <a
            routerLink="/"
            fragment="why-orient-house"
            (click)="closeMenu()"
            class="block rounded-xl px-4 py-4 text-white/80 hover:text-white hover:bg-white/5 text-2xl tracking-[0.01em] transition-colors"
            >Why Orient House</a
          >
        </li>
        <li>
          <a
            routerLink="/services"
            (click)="closeMenu()"
            class="block rounded-xl px-4 py-4 text-white/80 hover:text-white hover:bg-white/5 text-2xl tracking-[0.01em] transition-colors"
            routerLinkActive="!bg-white/10 !text-white"
            >Services</a
          >
          <ul class="mb-2 ml-4 border-l border-white/10 pl-3">
            <li *ngFor="let s of services">
              <a
                [routerLink]="['/services', s.slug]"
                (click)="closeMenu()"
                class="block rounded-lg px-3 py-2 text-base text-white/70 hover:text-white hover:bg-white/5 transition-colors"
                routerLinkActive="!bg-white/10 !text-white"
                >{{ s.title }}</a
              >
            </li>
          </ul>
        </li>
        <li>
          <a
            routerLink="/projects"
            (click)="closeMenu()"
            class="block rounded-xl px-4 py-4 text-white/80 hover:text-white hover:bg-white/5 text-2xl tracking-[0.01em] transition-colors"
            routerLinkActive="!bg-white/10 !text-white"
            >Projects</a
          >
        </li>
        <li>
          <a
            routerLink="/hse"
            (click)="closeMenu()"
            class="block rounded-xl px-4 py-4 text-white/80 hover:text-white hover:bg-white/5 text-2xl tracking-[0.01em] transition-colors"
            routerLinkActive="!bg-white/10 !text-white"
            >HSE</a
          >
        </li>
        <li>
          <a
            routerLink="/quality"
            (click)="closeMenu()"
            class="block rounded-xl px-4 py-4 text-white/80 hover:text-white hover:bg-white/5 text-2xl tracking-[0.01em] transition-colors"
            routerLinkActive="!bg-white/10 !text-white"
            >Quality</a
          >
        </li>

        <!-- CTA -->
        <li class="pt-6">
          <a
            routerLink="/contact"
            (click)="closeMenu()"
            routerLinkActive="bg-white/10"
            class="inline-flex w-full items-center justify-center h-12 rounded-full border border-white/25 text-white text-lg font-medium hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-white/30"
          >
            Contact
          </a>
        </li>
      </ul>
    </nav>
  </div>
</header>
